import {

    GET_COMPANY_TYPE_DEF_SUCCESS,
    ADD_COMPANY_TYPE_DEF_SUCCESS,
    UPDATE_COMPANY_TYPE_DEF_SUCCESS,
    DELETE_COMPANY_TYPE_DEF_SUCCESS,
    COMPANY_TYPE_DEF_API_ERROR
  } from "./actionTypes"
  
  const INIT_STATE = {
    recordList: [], //Model Data ve Error
    error: {},
  }
  
  const companyTypeDefinition = (state = INIT_STATE, action) => {
    switch (action.type) {
  
      case GET_COMPANY_TYPE_DEF_SUCCESS:
        return {
          ...state,
          recordList: action.payload,
  
        }
  
      case ADD_COMPANY_TYPE_DEF_SUCCESS:
        return {
          ...state,
          recordList: [...state.recordList, action.payload],
  
        }
  
      case UPDATE_COMPANY_TYPE_DEF_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.map(record =>
            record.guid.toString() === action.payload.guid.toString()
              ? { record, ...action.payload }
              : record
          ),
  
        }
  
      case DELETE_COMPANY_TYPE_DEF_SUCCESS:
        return {
          ...state,
          recordList: state.recordList.filter(
            record => record.guid.toString() !== action.payload.toString()
          ),
  
        }
  
      case COMPANY_TYPE_DEF_API_ERROR:
        return {
          ...state,
          error: action.payload,
          loading: false 
        }
  
      default:
  
        return state
  
    }
  }
  
  export default companyTypeDefinition